module.exports = __webpack_public_path__ + "images/blog/blog_balloon/doctor_22a33861405969a48c3e4c5892107fe6.png";